<div
  class="flex flex-col w-full h-full min-h-[600px] bg-body-background border border-secondary-border rounded-lg shadow-sm relative overflow-hidden"
>
  @if (!isInitialized()) {
    <div
      class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm"
    >
      <i class="fas fa-circle-notch fa-spin text-4xl text-primary mb-3"></i>
      <span class="text-secondary-text font-medium">{{
        config.texts.loading
      }}</span>
    </div>
  }

  <div
    #univerContainer
    class="w-full h-full flex-grow relative outline-none"
  ></div>
</div>
